'use client';

import { useShallow } from 'zustand/react/shallow';

import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';

export const useAdGuards = () => {
  const { isMounted, osType, webviewType } = useDeviceInfoStore(
    useShallow((state) => ({
      isMounted: state.isMounted,
      osType: state.osType,
      webviewType: state.webviewType,
    })),
  );

  const isWelloApp = webviewType === WEBVIEW_TYPE.WELLO_APP;
  const isExternalWebview =
    webviewType === WEBVIEW_TYPE.KB_PAY || webviewType === WEBVIEW_TYPE.TOSS;

  return { isMounted, isWelloApp, isExternalWebview, osType };
};
